// Module
var code = "<div class=\"modal-body text-center ng-scope\" id=\"modal-password-change-confirmation-body\"> <h2 style=\"font-weight:300\" translate>login.resetpass.password-updated</h2> </div> <div class=\"modal-footer text-center\"> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.login()\" translate>login.connect</button> </div>";
// Exports
export default code;